import { render, staticRenderFns } from "./biletbankaktarim.vue?vue&type=template&id=1cc7c69b&"
import script from "./biletbankaktarim.vue?vue&type=script&lang=js&"
export * from "./biletbankaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports